interface Props {
  streak: number;
}

export default function StreakBadge({ streak }: Props) {
  if (streak <= 0) {
    return (
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white shadow-soft text-sm text-ink/70">
        ✨ Start your streak today
      </div>
    );
  }
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sun/20 text-ink shadow-soft text-sm font-semibold">
      🔥 {streak}-day streak
    </div>
  );
}
